import { Carousel } from '@mantine/carousel';
import { Paper } from '@mantine/core';
import { CarouselLayout } from '../Shares/CarouselLayout';
import { GameChallengesCard } from './GameChallengesCard';
import { gameChallenge } from './data';
export const GameChallenges: React.FC = () => {
  return <Paper bg="transparent">
      <CarouselLayout id="game-challenge" items={gameChallenge} slideSize={{
      base: '50%',
      sm: '30%',
      md: '25%',
      xl: '20%'
    }}>
        {gameChallenge.map(item => <Carousel.Slide key={item.id}>
            <GameChallengesCard {...item} />
          </Carousel.Slide>)}
      </CarouselLayout>
    </Paper>;
};